
import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../commons/form/InputText'
import SimpleTablePage from '../../containers/commons/general/SimpleTablePage'
import { handleKeyDown } from '../../util/utils'

class SuppliedModal extends PureComponent {
  submitSupplied (values) {
    Object.keys(values).map(item => {
      if (values[item].languageId === undefined || values[item].languageId === null && (values[item].description !== null || values[item].name !== null)) {
        values[item].languageId = item.slice(-1)
      }
    })
    const body = []
    Object.keys(values).map(item => {
      body.push(values[item])
    })
    this.props.actions.saveSuppliedModal(this.props.uoId, body, this.props.suppliedId)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.suppliedTypeLanguages !== nextProps.suppliedTypeLanguages &&
      nextProps.suppliedTypeLanguages.length > 0) {
      nextProps.languageList.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const source = nextProps.suppliedTypeLanguages.find((sourceChannel) => sourceChannel.languageId === language.languageId)
        this.props.change(`lang${language.languageId}.name`, source ? source.name : '')
        this.props.change(`lang${language.languageId}.description`, source ? source.description : '')
      })
    }
  }

  render () {
    const { t, showSuppliedModal, handleSubmit, languageList = [] } = this.props
    return (
      <Modal id="suppliedModal" show={showSuppliedModal} onHide={this.props.actions.closeSuppliedModal} className="_nf">
        <Modal.Header closeButton>
          <Modal.Title>{t('MASTERS.SUPPLIED_MASTERS.SUPPLIED')}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitSupplied.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button type="submit" className="_Btn new">
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`]) {
      if (!(values[`lang${language.languageId}`].name)) {
        errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      }
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
      }
    } else {
      errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
    }
  })
  return errors
}

export default reduxForm({
  form: 'editSupplied',
  validate
})(SuppliedModal)
